import MissionService from '../../../../../service/mission';
import UseRecordService from '../../../../../service/useRecord';
export const GET_MONTHLY_DATA = '[ANALYTICS DASHBOARD APP] GET MONTHLY DATA';
export const GET_RANKING_DATA = '[ANALYTICS DASHBOARD APP] GET RANKING DATA';

export function getMonthlyData(year)
{
    return async (dispatch) => {
        try {
            const data = await MissionService.getMonthlyData(year);
            dispatch({type: GET_MONTHLY_DATA, data});
            return data;
        } catch (error) {
            throw dispatch({error});
        }
    };
}

export function getRankingData()
{
    return async (dispatch) => {
        try {
            const data = await UseRecordService.getRankingData();
            dispatch({type: GET_RANKING_DATA, ...data});
            return data;
        } catch (error) {
            throw dispatch({ error });
        }
    };
}



// WEBPACK FOOTER //
// ./src/main/content/analytics/store/actions/widgets.actions.js